import {
  CustomMappingType,
  ICustomMapping,
  IPracticeMigration,
} from '@principle-theorem/practice-migrations/interfaces';
import { WithRef, toInt } from '@principle-theorem/shared';
import { isString } from 'lodash';
import { CustomMapping } from '../../../custom-mapping';
import { SingleValueMappingHandler } from '../../../mappings/single-value';
import { TranslationMapHandler } from '../../../translation-map';
import { IOasisPatientAppointment } from '../../source/entities/patient-appointments';

const OASIS_STEP_SIZE_OPTIONS = ['5', '10', '15', '20'];
const DEFAULT_OASIS_STEP_SIZE = '5';

export const OASIS_APPOINTMENT_STEP_SIZE_CUSTOM_MAPPING_TYPE =
  'oasisAppointmentStepSizeCustomMapping';

export const OASIS_APPOINTMENT_STEP_SIZE_MAPPING: ICustomMapping =
  CustomMapping.init({
    metadata: {
      label: 'Appointment Step Size',
      description: 'Minutes per OASiS appointment slot. Default 5.',
      type: OASIS_APPOINTMENT_STEP_SIZE_CUSTOM_MAPPING_TYPE,
    },
    type: CustomMappingType.SingleValue,
    inputType: 'select',
    placeholder: 'Select Appointment Step Size',
    hint: 'Default step size is 5 minutes.',
    options: OASIS_STEP_SIZE_OPTIONS.map((value) => ({
      label: `${value} Minutes`,
      value,
    })),
  });

export class OasisAppointmentStepSizeMappingHandler extends SingleValueMappingHandler {
  customMapping = OASIS_APPOINTMENT_STEP_SIZE_MAPPING;

  async getAppointmentDuration(
    migration: WithRef<IPracticeMigration>,
    appointment: IOasisPatientAppointment
  ): Promise<number> {
    const translationMap = new TranslationMapHandler(migration);
    const stepSize = await this.getBySource(
      this.customMapping.metadata.type,
      translationMap
    );

    const value = stepSize?.destinationValue?.value;
    const minutes =
      isString(value) &&
      OASIS_STEP_SIZE_OPTIONS.includes(value)
        ? toInt(value)
        : toInt(DEFAULT_OASIS_STEP_SIZE);

    return appointment.duration * minutes;
  }
}
